import { RootState } from 'redux/store';
import { Table } from 'components/Table';
import { Badge, Col, Row, Button } from 'react-bootstrap';
import { useAppSelector } from 'redux/hooks';
import { useEffect, useState } from 'react';

const StoreStocks = () => {
    const [showPurchase, setShowPurchase] = useState<boolean>(true);
    const [showSales, setShowSales] = useState<boolean>(true);
    const [storeStocksTable, setStoreStocksTable] = useState<any[]>([]);
    const storeStocks = useAppSelector((state: RootState) => state.storeStocks);
    const stores = useAppSelector((state: RootState) => state.stores);

    useEffect(() => {
        let storeIds = stores.table.map((i:any) => i.id);
        setStoreStocksTable(storeStocks.table.filter((i:any) => storeIds.includes(i.storeId)));
    }, [stores.table, storeStocks.table])

    const columns = [
        {
            Header: 'Store Name',
            accessor: 'storeInitialName',
            defaultCanSort: false,
        },
        {
            Header: 'Status',
            accessor: 'storeStatus',
            defaultCanSort: false,
            Cell: (row: any) => {
                return (
                    <>
                        {row.cell.row.original.errors.length === 1 && <Badge className="me-1 badge-outline-danger">Offline</Badge>}
                        {row.cell.row.original.errors.length === 0 && <Badge className="me-1 badge-outline-primary">Online</Badge>}
                    </>
                );
            }
        },
        {
            Header: 'Stock Name',
            accessor: 'name',
            defaultCanSort: false,
        },
        {
            Header: 'SOH',
            accessor: 'shopSOH',
            defaultCanSort: false,
        },
        {
            Header: 'Cost',
            accessor: 'costEx',
            defaultCanSort: false,
        },
        {
            Header: 'GP%',
            accessor: 'gp',
            defaultCanSort: false,
			Cell: (row: any) => {return row.cell.row.original.gp?.toFixed(2) ?? ""}
        },
        {
            Header: 'Sell Price',
            accessor: 'sellPrice',
            defaultCanSort: false,
        },
    ];

    function generateMonths() {
        const currentDate = new Date();
        const months = [];

        for (let i = 0; i < 12; i++) {
            const month = currentDate.getMonth() - i;
            let year = currentDate.getFullYear();

            if (month < 0) {
                year--;
            }
            const yearString = year.toString().slice(-2);

            const monthObject = {
                Header: `${new Intl.DateTimeFormat('en-US', { month: 'short' }).format(new Date(year, month))} ${yearString}`,
                accessor: `month${i}`,
                defaultCanSort: false,
                Cell: (row: any) => {
                    return (
                        <div style={{ display: 'grid', justifyItems: 'center' }}>
                            {showPurchase ? (<div style={{ marginBottom: '2px', color: "#00B4AA", fontWeight: 'bold' }}>{row.cell.row.original.purchaseHistory[i].qty} </div>) : (<></>)}
                            {showSales ? (<div style={{ color: "#fa5c7c", fontWeight: 'bold' }}>{row.cell.row.original.salesHistory[i].qty}</div>) : (<></>)}
                        </div>
                    );
                }
            };
            months.push(monthObject);
        }

        return months;
    }

    const months = generateMonths();

    const columnsb = [
        {
            Header: 'Store Name',
            accessor: 'storeInitialName',
            defaultCanSort: false,
        },
        {
            Header: 'Stock Name',
            accessor: 'name',
            defaultCanSort: false,
        },
        {
            Header: 'Avg Mov',
            accessor: 'shopSOH',
            defaultCanSort: false,
            Cell: (row: any) => {
                return (
                    <div style={{ display: 'grid', justifyItems: 'center', boxSizing: 'inherit' }}>
                        {showPurchase ? (<div style={{ marginBottom: '2px', color: "#00B4AA", fontWeight: 'bold' }}>{row.cell.row.original.purchaseHistory[0].qty} </div>) : (<></>)}
                        {showSales ? (<div style={{ color: '#fa5c7c', fontWeight: 'bold' }}>{row.cell.row.original.salesHistory[0].qty}</div>) : (<></>)}
                    </div>
                );
            }
        },
        ...months,
    ];

    const topbarChildren = (
        <>
            <button className={showPurchase ? "me-1 btn btn-primary" : "me-1 btn btn-outline-primary"} style={{ padding: '7.2px' }} onClick={() => setShowPurchase(!showPurchase)}>Purchase History</button>
            {" "}
            <button className={showSales ? "me-1 btn btn-danger" : "me-1 btn btn-outline-danger"} style={{ padding: '7.2px' }} onClick={() => setShowSales(!showSales)}>Sales History</button>
            {" "}
        </>
    );

    return (
        <Row>
            <Col md={12}>
                <Table
                    hideToolbar
                    columns={columns}
                    data={storeStocksTable}
                    pageSize={15}
                    isSortable={true}
                    pagination={true}
                    isSearchable={false}
                    disableExport={true}
                    autoHeight={true}
                // maxHeight={400}
                />
                <Table
                    title="Stock Movement"
                    columns={columnsb}
                    data={storeStocksTable}
                    pageSize={15}
                    isSortable={true}
                    pagination={true}
                    isSearchable={false}
                    disableExport={true}
                    autoHeight={true}
                    className="custom-yearly-table"
                    topbarChild={topbarChildren}
                // maxHeight={400}
                />
            </Col>
        </Row>
    );
};

export default StoreStocks;
